
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repayments-calculator/results",
      function () {
        return require("private-next-pages/repayments-calculator/results.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repayments-calculator/results"])
      });
    }
  